__turbopack_context__.v({
  "toolButton": "KUdbRG_toolButton",
});
